import React from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import rocketIcon from "../../imgs/rocketfi_yellow_token.png";
import { formatDecimals, formatWalletAddress, formatCurrencyExtended, formatBalanceWithIcon} from '../../utils';
import {
    infoStyle, cardHeaderStyle
  } from "./TileStyles";

// New component for displaying the RocketFi balance
const DashboardBalance = ({ data, account, rocketFiPrice, smartCodeData }) => {
  // Maintain existing styles for token card
  const tokenCardStyle = {
    background: "#333333",
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    backgroundImage: `linear-gradient(263deg, rgb(250 202 90 / 85%), rgb(45 45 80 / 85%)), url(${rocketIcon}), linear-gradient(153deg,rgb(0, 0, 0), rgb(0, 0, 0) 19%, rgb(0, 0, 0))`,
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    gridColumn: 'span 2',
    gridRow: 'span 1'
  };

  return (

    <Card title={
        <div style={cardHeaderStyle}>
          {<>
            <Button outlined disabled rounded
              style={{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '2px', paddingBottom: '2px', marginBottom: '4px', color: 'white', size: 'lg',
                backgroundColor: 'black', fontSize: '14px', fontWeight: 'bold'
              }}>
              {
                smartCodeData?.smartCode !== undefined && smartCodeData?.smartCode !== ''
                  ?  smartCodeData?.smartCode : formatWalletAddress(account) 
              }</Button>
            <br />
          </>}
          RocketFi Balance</div>
      }
      style={
        tokenCardStyle
      }>
      <div style={infoStyle}>
        {data?.contractData?.tokenData?.rocketFiBalance !== undefined && data.dbData 
          ? formatBalanceWithIcon(
            data.contractData.tokenData.rocketFiBalance, 
            "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", 
            data.dbData, 
            9
          )
          : <Skeleton width="100%" height="35px" className="mb-2" />}
      </div>
      <div>
        {data?.contractData ?
          formatCurrencyExtended((data?.contractData?.tokenData?.rocketFiBalance / (10 ** 9)) * rocketFiPrice) : <Skeleton width="100%" height="35px" className="mb-2" />
        }
      </div>
    </Card>

  );
};

export default DashboardBalance;